"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const appStateSelectControlParentById_1 = __importDefault(require("../shared/appStateSelectControlParentById"));
const General_1 = require("../types/General");
const useAppStateSelector_1 = __importDefault(require("./useAppStateSelector"));
const useControlParentNotNewById = (id) => {
    const parentFromSelector = (0, useAppStateSelector_1.default)((0, appStateSelectControlParentById_1.default)(id));
    return parentFromSelector && parentFromSelector[General_1.DEFINITION_PROP_NAMES.IS_NEW] !== 1
        ? parentFromSelector
        : null;
};
exports.default = useControlParentNotNewById;
